import { isDefined } from "@clipboard-health/util-ts";

import { type UseBoostLimitIncreaseRequestResult } from "../../hooks/useBoostLimitIncreaseRequest";
import { formatWeekRange } from "../../utils/formatWeekRange";
import { SpendingLimitIncreaseRequestModal } from "./SpendingLimitIncreaseRequestModal";

interface BoostIncreaseRequestModalProps {
  increaseRequest: UseBoostLimitIncreaseRequestResult;
  weekStartDate: Date | undefined;
  workplaceId: string;
  onSuccess?: () => void;
}

/**
 * Renders the boost increase-request dialog from a `useBoostLimitIncreaseRequest` result, so every
 * charge surface (calendar/schedule/invite) shares one wiring instead of duplicating the modal.
 */
export function BoostIncreaseRequestModal(props: BoostIncreaseRequestModalProps) {
  const { increaseRequest, weekStartDate, workplaceId, onSuccess } = props;
  const { modalState, context, controlType } = increaseRequest;

  if (!modalState.modalIsOpen || !isDefined(weekStartDate)) {
    return null;
  }

  return (
    <SpendingLimitIncreaseRequestModal
      controlType={controlType}
      currentLimitInDollars={context?.currentLimitInDollars}
      modalState={modalState}
      overageInMinorUnits={context?.overageInMinorUnits ?? 0}
      qualification={context?.qualification}
      presentation="dialog"
      weekRange={formatWeekRange(weekStartDate)}
      weekStartDate={weekStartDate}
      workplaceId={workplaceId}
      onBack={increaseRequest.back}
      onSuccess={() => {
        increaseRequest.markRequested();
        onSuccess?.();
      }}
    />
  );
}
